import React from "react"
import Accordion from "../FoldersV2/Accordion"
import { cn } from "@/utils/cn"
import GridBreakpointColsContainer from "@/components/GridBreakpointColsContainer"
import Masonry from "@/components/Masonry"
import { getWorkspaceBreakpointCols } from "@/utils/grid-cols"

interface RecentAccordionProps {
  name: string
  children: React.ReactNode
  layout: "grid" | "list"
  gridClassName?: string
  listClassName?: string
  containerWidth?: number
  modeGrid?: "masonry" | "grid"
}

const RecentAccordion = ({
  name,
  children,
  containerWidth,
  layout,
  listClassName,
  gridClassName,
  modeGrid = "grid",
}: RecentAccordionProps) => {
  return (
    <div className="overflow-hidden mb-4">
      <Accordion
        defaultOpen
        title={name}
        disabledTitleClick={name.toLowerCase().includes("older")}
        hiddenButton={name.toLowerCase().includes("older")}
      >
        {() => (
          <div className="overflow-hidden">
            {layout === "grid" ? (
              modeGrid === "masonry" ? (
                <Masonry
                  breakpointCols={{
                    default: getWorkspaceBreakpointCols(containerWidth ?? 0),
                  }}
                  className="flex w-full gap-1 md:gap-2 lg:gap-4"
                  columnClassName="gap-1 md:gap-2 lg:gap-4 flex flex-col"
                >
                  {children}
                </Masonry>
              ) : (
                <GridBreakpointColsContainer className={gridClassName}>{children}</GridBreakpointColsContainer>
              )
            ) : (
              <div className={cn("flex flex-col space-y-1", listClassName)}>{children}</div>
            )}
          </div>
        )}
      </Accordion>
    </div>
  )
}

export default RecentAccordion
